export const translations = {
  en: {
    nav: {
      home: "HOME",
      plans: "MEMBERSHIP PLANS",
      free_tip: "TODAY'S FREE TIP",
      doubles_archives: "DOUBLES ARCHIVES",
      about: "ABOUT HAKAN TIPSTER",
      contact: "CONTACT",
      help: "HELP",
      buy: "BUY TIPS",
    },
    hero: {
      overline: "🇹🇷 İSTANBUL // TURKEY — ELITE FOOTBALL ANALYTICS PRECISION",
      title_line_1: "PRECISION",
      title_line_2: "OVER LUCK.",
      title_line_3: "EVERY MATCHDAY.",
      lede:
        "Meet Hakan Kazcıoğlu — the mind behind the edge. Based in Istanbul, Hakan leads an elite team of 5 veteran tipsters. Every single day we spend a minimum of 5 hours analyzing tactical shifts, market movements, squad depth and insider data. We don’t rely on luck — we rely on deep-dive analytical engineering to deliver premium value to our members worldwide.",
      cta_primary: "BUY TIPS",
      cta_secondary: "SEE PAST RESULTS",
      badge_founder: "VERIFIED MEMBER WINS",
      badge_name: "REAL WINNERS. REAL SLIPS.",
    },
    stats: {
      title: "THE NUMBERS BEHIND THE EDGE",
      subtitle: "Track record from our verified in-house archive",
      total_tips: "TOTAL LIFETIME TIPS",
      roi: "ROI",
      analysts: "TOTAL TIPSTERS",
      free_tips_btn: "FREE TIPS",
    },
    about: {
      overline: "ABOUT THE TIPSTER",
      badge: "FOUNDER · LEAD ANALYST",
      title: "ABOUT MR. HAKAN",
      paragraphs: [
        "Mr. Hakan is a professional football analyst and tipster with more than 15 years of experience in football prediction and match analysis. His approach is built around detailed research, disciplined selection, and long-term consistency rather than random picks or guesswork.",
        "Every day, Mr. Hakan focuses on carefully selected football matches and conducts at least 5 hours of detailed analysis, studying team form, statistics, recent performances, tactical tendencies, injuries, squad news, motivation, and other important factors before making a selection.",
        "His daily strategy focuses on Double selections — two carefully selected matches per day, with the combined odds always above 2.50. The goal is to provide carefully researched combinations while maintaining a disciplined and consistent approach.",
        "Mr. Hakan also works alongside experienced analysts and trusted collaborators who have been involved in football analysis and sports prediction for more than 20 years. This combined experience allows the team to evaluate matches from multiple perspectives and focus on finding selections with genuine statistical and analytical value.",
        "With thousands of analyzed matches behind him, Mr. Hakan's philosophy is simple:",
      ],
      quote: "Research over hype. Discipline over emotion. Analysis over luck.",
      closing: "Every selection is the result of research, discussion, and careful evaluation — never a random guess.",
    },
    marquee:
      "PRECISION · DISCIPLINE · VALUE · EXPERTISE · İSTANBUL · HAKAN TIPS · PRECISION · DISCIPLINE · VALUE · EXPERTISE · İSTANBUL · HAKAN TIPS ·",
    manifesto: {
      overline: "THE METHOD // MANIFESTO",
      title: "FIVE MINDS. ONE EDGE.",
      chapters: [
        {
          n: "01",
          title: "TACTICAL DECONSTRUCTION",
          body:
            "We break down every fixture at the shape level — pressing triggers, transition maps, set-piece routines and manager tendencies. If a tactic changes on Friday, we know by Saturday morning.",
        },
        {
          n: "02",
          title: "MARKET INTELLIGENCE",
          body:
            "Line movements tell a story. Our team tracks sharp money, opening-to-close drifts and steam moves across regulated markets to find where the true price actually lives.",
        },
        {
          n: "03",
          title: "SQUAD & CONTEXT MODEL",
          body:
            "Rotation risk, travel fatigue, referee tendencies, weather, motivation. Every intangible is graded and weighted before a single tip leaves the desk.",
        },
        {
          n: "04",
          title: "INSIDER SIGNALS",
          body:
            "Fifteen years of contacts across Süper Lig, La Liga, Serie A and beyond. When something matters, we hear it — hours before the public feed.",
        },
        {
          n: "05",
          title: "DISCIPLINED DELIVERY",
          body:
            "No noise. No hero picks. Just staked, structured, high-value football tips delivered to your inbox with the exact confidence level attached.",
        },
      ],
    },
    plans: {
      overline: "MEMBERSHIP PLANS",
      title: "PICK YOUR EDGE.",
      subtitle:
        "Simple, honest pricing. No subscriptions locked behind a paywall — you buy the tips you want, when you want them.",
      most_popular: "MOST POPULAR",
      best_value: "BEST VALUE",
      features: {
        tips: (n) => `${n} days of premium football tips`,
        analysis: "Full written analysis for every pick",
        odds: "Recommended bookmaker & fair odds",
        stake: "Suggested stake & confidence rating",
        support: "Priority Telegram support",
        replacement: "Free replacement on postponed matches",
      },
      cta: "GET THIS PLAN",
      currency: "EUR",
      note: "One-time payment · No auto-renewal · Handled personally by our team",
      guarantee_overline: "OUR GUARANTEE",
      guarantee_before: "Every losing day",
      guarantee_highlight: "= 1 free replacement day",
      guarantee_after: "after your subscription ends.",
      not_available: "NOT AVAILABLE",
    },
    freeTip: {
      overline: "DAILY FREE TIP",
      title: "FREE TIP OF THE DAY",
      free_badge: "FREE",
      tip: "TIP",
      odds: "ODDS",
      history: "PREVIOUS FREE TIPS",
      match: "MATCH",
      result: "RESULT",
      btn_plans: "SUBSCRIPTION PACKAGE",
      btn_archive: "ARCHIVE",
      banner_disclaimer: "We disclaim any responsibility for the banners displayed on our website and state that they are used exclusively to increase traffic to our website.",
      note: "Free Tip matches and subscription matches are completely different, coming from different tipsters. The key difference lies in their level of knowledge, connections, and dedication.",
    },
    archive: {
      overline: "PAST RESULTS / ARCHIVE",
      title: "RECEIPTS. NOT PROMISES.",
      subtitle:
        "A live-updated log of our recent premium tips. Wins and losses — nothing hidden.",
      date: "DATE",
      match: "MATCH",
      league: "LEAGUE",
      tip: "TIP",
      odds: "ODDS",
      result: "RESULT",
      no_double: "NO SUBSCRIPTION DOUBLE",
      win: "WIN",
      loss: "LOSS",
      draw: "DRAW",
      full_archive: "CLICK HERE FOR THE FULL ARCHIVE",
      view_more: "VIEW FULL ARCHIVE",
    },
    contact: {
      overline: "GET IN TOUCH",
      title: "READY TO WORK WITH THE DESK?",
      subtitle:
        "Drop us a message — Hakan or one of our senior analysts will personally reply within 12 hours.",
      name: "Your name",
      email: "Email address",
      subject: "Subject",
      message: "Your message",
      submit: "SEND MESSAGE",
      sending: "SENDING...",
      success: "Message received. We’ll be in touch within 12 hours.",
      error: "Something went wrong. Please try again.",
    },
    footer: {
      tagline: "İstanbul-based football intelligence.",
      rights: "All rights reserved.",
      cols: {
        product: "PRODUCT",
        legal: "LEGAL",
        contact: "CONTACT",
      },
      links: {
        home: "Home",
        plans: "Membership Plans",
        archive: "Past Results",
        terms: "Terms & Conditions",
        privacy: "Privacy Policy",
        disclaimer: "Disclaimer",
        cookies: "Cookie Policy",
        contact: "Contact",
      },
      responsible:
        "18+ ONLY. Please gamble responsibly. Sports betting involves risk. HAKAN TIPS is an analytical service and does not accept, place or facilitate any wager.",
    },
    testimonials: {
      overline: "MEMBER VOICES",
      title: "TRUSTED BY BETTORS WORLDWIDE.",
      subtitle:
        "Real feedback from our verified members. Independent reviews on Trustpilot.",
      trustpilot: "Rated Excellent on Trustpilot",
      score: "4.8 / 5",
      reviews: "based on 1,247 verified reviews",
      items: [
        { name: "Marco B.", country: "Italy 🇮🇹", stars: 5, text: "Best tipster I've followed in 10 years. The 15 TIPS pack paid for itself in one weekend. Rock-solid analysis every time." },
        { name: "Kenan Y.", country: "Türkiye 🇹🇷", stars: 5, text: "Hakan's Süper Lig reads are unreal — accurate 8 out of 10 times. The written analysis alone is worth the price." },
        { name: "James O.", country: "UK 🇬🇧", stars: 5, text: "Zero fluff, no fake screenshots, just receipts. I've been a member for 6 months and my bankroll is up 41%." },
        { name: "Andreas M.", country: "Germany 🇩🇪", stars: 5, text: "Fast delivery, clear reasoning, honest results tracking. This is how professional tipping should look." },
        { name: "Diego R.", country: "Spain 🇪🇸", stars: 5, text: "The confidence rating system is a game-changer. High-conviction picks come through consistently." },
        { name: "Ali K.", country: "UAE 🇦🇪", stars: 5, text: "Fast, professional, and always delivers exactly as promised. Very happy with the service and results." },
      ],
    },
    payments: {
      overline: "SECURE PAYMENT",
      title: "MULTIPLE PAYMENT OPTIONS.",
      subtitle:
        "We accept a wide range of secure, discreet payment methods. All transactions are processed personally by our team — no online forms, no stored card data.",
      note: "Contact us to complete your order. Full instructions delivered on request.",
      methods: [
        "Skrill",
        "Neteller",
        "PayPal",
        "Crypto (BTC / USDT / ETH)",
        "Western Union",
        "MoneyGram",
        "Ria Money Transfer",
        "Ukash",
      ],
    },
    admin: {
      login_title: "ADMIN ACCESS",
      login_subtitle: "Restricted area. Authorized personnel only.",
      email: "Email",
      password: "Password",
      login: "SIGN IN",
      logout: "LOGOUT",
      dashboard: "ARCHIVE MANAGER",
      welcome: "Welcome back",
      add_new: "+ ADD NEW RESULT",
      edit: "EDIT",
      delete: "DELETE",
      save: "SAVE",
      cancel: "CANCEL",
      confirm_delete: "Delete this result?",
      form: {
        date: "Date (YYYY-MM-DD)",
        league: "League",
        match: "Match",
        tip: "Tip",
        odds: "Odds",
        result: "Result",
      },
      login_error: "Invalid credentials.",
      login_success: "Signed in.",
      saved: "Saved.",
      deleted: "Deleted.",
    },
    legal: {
      lastUpdated: "Last updated: December 2025",
      backHome: "← BACK TO HOME",
      terms: {
        title: "TERMS & CONDITIONS",
        intro:
          "These Terms & Conditions (\"Terms\") govern your access to and use of the website www.hakan-tips.com (\"the Website\") and any related services (collectively, \"the Service\") operated by HAKAN TIPS (\"we\", \"us\", \"our\"). By accessing or using the Service you agree to be bound by these Terms.",
          sections: [
            {
              h: "1. Nature of the Service",
              p:
                "HAKAN TIPS is an information and analytical service. We provide football analysis, tips and predictions for entertainment and informational purposes. We do not accept, hold or facilitate wagers, and we are not a bookmaker.",
            },
            {
              h: "2. Eligibility",
              p:
                "You must be at least 18 years old (or the legal age of majority in your jurisdiction, whichever is higher) to use the Service. You confirm that using our tips is legal in your country of residence.",
            },
            {
              h: "3. No Guarantee",
              p:
                "All predictions and tips are opinions based on statistical analysis and professional judgement. Past performance is not indicative of future results. We make no guarantee of profit and accept no responsibility for financial losses incurred through use of our content.",
            },
            {
              h: "4. Purchases & Refunds",
              p:
                "Membership tips are sold on a one-time basis. Because of the digital and time-sensitive nature of the content, all sales are final and non-refundable once tips have been delivered.",
            },
            {
              h: "5. Intellectual Property",
              p:
                "All content, analysis, branding and code on the Website is the property of HAKAN TIPS. You may not resell, redistribute or publish our tips without prior written consent.",
            },
            {
              h: "6. Account Conduct",
              p:
                "You agree not to misuse the Service, share paid content, or use it for any unlawful purpose. We may suspend access without refund for breach of these Terms.",
            },
            {
              h: "7. Limitation of Liability",
              p:
                "To the maximum extent permitted by law, HAKAN TIPS shall not be liable for any indirect, incidental or consequential damages arising from your use of the Service.",
            },
            {
              h: "8. Governing Law",
              p:
                "These Terms are governed by the laws of the Republic of Türkiye. Any dispute shall be resolved before the competent courts of Istanbul.",
            },
            {
              h: "9. Changes",
              p:
                "We may update these Terms at any time. Continued use of the Website after changes constitutes acceptance of the updated Terms.",
            },
          ],
      },
      privacy: {
        title: "PRIVACY POLICY",
        intro:
          "This Privacy Policy explains how HAKAN TIPS collects, uses and protects the personal information you provide when using www.hakan-tips.com.",
          sections: [
            {
              h: "1. Information We Collect",
              p:
                "We collect information you provide directly (name, email, message content) via our contact form, as well as basic technical data (IP address, browser type, pages viewed) via standard analytics tools.",
            },
            {
              h: "2. How We Use Your Data",
              p:
                "Your data is used solely to respond to your inquiries, deliver purchased tips, improve the Website and comply with legal obligations. We do not sell your data.",
            },
            {
              h: "3. Legal Basis",
              p:
                "We process personal data under the legal bases of consent, contract performance and legitimate interest, in line with the GDPR and the Turkish KVKK.",
            },
            {
              h: "4. Data Sharing",
              p:
                "We share data only with trusted processors (hosting, email delivery, analytics) under strict data-processing agreements. We never share your data with betting operators.",
            },
            {
              h: "5. Data Retention",
              p:
                "Contact messages are retained for up to 24 months. You may request deletion at any time by contacting privacy@hakan-tips.com.",
            },
            {
              h: "6. Your Rights",
              p:
                "You have the right to access, rectify, delete, restrict or port your personal data, and to withdraw consent at any time.",
            },
            {
              h: "7. Security",
              p:
                "We use industry-standard encryption (TLS) and access controls. However, no method of transmission over the internet is 100% secure.",
            },
            {
              h: "8. Contact",
              p:
                "For any privacy question, contact privacy@hakan-tips.com.",
            },
          ],
      },
      disclaimer: {
        title: "DISCLAIMER",
        intro:
          "The information provided by HAKAN TIPS on www.hakan-tips.com is for general informational and entertainment purposes only.",
          sections: [
            {
              h: "1. No Financial Advice",
              p:
                "Nothing on this Website constitutes financial, investment, or professional advice. Any decision to place a wager is made at your sole discretion and risk.",
            },
            {
              h: "2. Betting Risk",
              p:
                "Sports betting involves substantial financial risk. You may lose all funds you stake. Only wager amounts you can comfortably afford to lose.",
            },
            {
              h: "3. Responsible Gambling",
              p:
                "If you or someone you know struggles with problem gambling, please contact a national helpline such as BeGambleAware, GamCare, or the Turkish Green Crescent (Yeşilay).",
            },
            {
              h: "4. External Links",
              p:
                "The Website may contain links to third-party websites. We are not responsible for the content, accuracy or practices of those sites.",
            },
            {
              h: "5. No Warranty",
              p:
                "All content is provided \"as is\" without warranty of any kind, express or implied.",
            },
          ],
      },
      cookies: {
        title: "COOKIE POLICY",
        intro:
          "This Cookie Policy explains how HAKAN TIPS uses cookies and similar technologies on www.hakan-tips.com.",
          sections: [
            {
              h: "1. What are Cookies?",
              p:
                "Cookies are small text files stored on your device that help websites function, remember preferences and analyse traffic.",
            },
            {
              h: "2. Types of Cookies We Use",
              p:
                "We use strictly necessary cookies (site functionality), preference cookies (language selection), and anonymous analytics cookies to understand how visitors use the Website.",
            },
            {
              h: "3. Third-Party Cookies",
              p:
                "Some cookies may be set by third-party services such as Google Analytics. These providers have their own privacy policies which we recommend reviewing.",
            },
            {
              h: "4. Managing Cookies",
              p:
                "You can control or delete cookies at any time via your browser settings. Blocking some cookies may affect the functionality of the Website.",
            },
            {
              h: "5. Updates",
              p:
                "We may update this Cookie Policy periodically. The date at the top reflects the most recent revision.",
            },
          ],
      },
    },
  },
  tr: {
    nav: {
      home: "ANASAYFA",
      plans: "ÜYELİK PAKETLERİ",
      free_tip: "GÜNÜN ÜCRETSİZ TAHMİNİ",
      doubles_archives: "ÇİFT ARŞİVİ",
      about: "HAKAN TİPSTER HAKKINDA",
      contact: "İLETİŞİM",
      help: "YARDIM",
      buy: "TAHMİN AL",
    },
    hero: {
      overline: "🇹🇷 İSTANBUL // TÜRKİYE — SEÇKİN FUTBOL ANALİTİĞİ PRESİZYON",
      title_line_1: "ŞANS DEĞİL,",
      title_line_2: "PRESİZYON.",
      title_line_3: "HER MAÇ GÜNÜ.",
      lede:
        "Hakan Kazcıoğlu ile tanışın — kazanan tarafın arkasındaki zeka. İstanbul merkezli Hakan, 5 kişilik veteran analist ekibimize liderlik ediyor. Her gün en az 5 saatimizi taktiksel değişimleri, piyasa hareketlerini, kadro derinliğini ve iç kaynak verilerini analiz etmeye ayırıyoruz. Şansa değil; derinlemesine analitik mühendisliğe güveniyoruz — ve premium değeri dünya çapındaki üyelerimize sunuyoruz.",
      cta_primary: "TAHMİN AL",
      cta_secondary: "GEÇMİŞ SONUÇLARI GÖR",
      badge_founder: "DOĞRULANMIŞ ÜYE KAZANÇLARI",
      badge_name: "GERÇEK KAZANANLAR. GERÇEK KUPONLAR.",
    },
    stats: {
      title: "SAYILAR YALAN SÖYLEMEZ",
      subtitle: "Doğrulanmış kurum içi arşivimizden istatistikler",
      total_tips: "TOPLAM TAHMİN",
      roi: "ROI",
      analysts: "TOPLAM TİPSTER",
      free_tips_btn: "ÜCRETSİZ TAHMİNLER",
    },
    about: {
      overline: "TİPSTER HAKKINDA",
      badge: "KURUCU · BAŞ ANALİST",
      title: "MR. HAKAN HAKKINDA",
      paragraphs: [
        "Mr. Hakan, futbol tahmini ve maç analizi alanında 15 yılı aşkın deneyime sahip profesyonel bir futbol analisti ve tipsterdir. Yaklaşımı; rastgele seçimler veya tahmin yerine detaylı araştırma, disiplinli seçim ve uzun vadeli tutarlılık üzerine kuruludur.",
        "Mr. Hakan her gün özenle seçilmiş futbol maçlarına odaklanır ve seçim yapmadan önce takım formunu, istatistikleri, güncel performansları, taktiksel eğilimleri, sakatlıkları, kadro haberlerini, motivasyonu ve diğer önemli faktörleri inceleyerek en az 5 saat detaylı analiz yapar.",
        "Günlük stratejisi Çift Kombine seçimlere odaklıdır — günde iki dikkatle seçilmiş maç, birleşik oranı her zaman 2.50'nin üzerinde. Amaç; disiplinli ve tutarlı bir yaklaşımı korurken iyi araştırılmış kombinasyonlar sunmaktır.",
        "Mr. Hakan ayrıca futbol analizi ve spor tahmini alanında 20 yılı aşkın süredir görev alan deneyimli analistler ve güvenilir iş ortaklarıyla birlikte çalışmaktadır. Bu birleşik deneyim, ekibin maçları birden fazla açıdan değerlendirmesine ve gerçek istatistiksel-analitik değere sahip seçimler bulmaya odaklanmasına olanak tanır.",
        "Binlerce analiz edilmiş maçın arkasında olan Mr. Hakan'ın felsefesi basittir:",
      ],
      quote: "Hype yerine araştırma. Duygu yerine disiplin. Şans yerine analiz.",
      closing: "Her seçim; araştırma, tartışma ve dikkatli değerlendirmenin sonucudur — asla rastgele bir tahmin değildir.",
    },
    marquee:
      "PRESİZYON · DİSİPLİN · DEĞER · UZMANLIK · İSTANBUL · HAKAN TIPS · PRESİZYON · DİSİPLİN · DEĞER · UZMANLIK · İSTANBUL · HAKAN TIPS ·",
    manifesto: {
      overline: "YÖNTEM // MANİFESTO",
      title: "BEŞ ZİHİN. TEK AVANTAJ.",
      chapters: [
        {
          n: "01",
          title: "TAKTİKSEL ÇÖZÜMLEME",
          body:
            "Her karşılaşmayı şema düzeyinde analiz ediyoruz — pres tetikleyicileri, geçiş haritaları, duran top rutinleri ve teknik direktör eğilimleri. Bir taktik cuma günü değişirse, biz cumartesi sabahına kadar biliyoruz.",
        },
        {
          n: "02",
          title: "PİYASA ZEKASI",
          body:
            "Oran hareketleri her şeyi anlatır. Ekibimiz düzenli piyasalardaki keskin para akışını, açılış-kapanış farklarını ve steam hareketlerini takip ederek gerçek fiyatın nerede olduğunu tespit eder.",
        },
        {
          n: "03",
          title: "KADRO & BAĞLAM MODELİ",
          body:
            "Rotasyon riski, seyahat yorgunluğu, hakem eğilimleri, hava durumu, motivasyon. Tek bir tahmin masayı terk etmeden önce her soyut faktör puanlanır ve ağırlıklandırılır.",
        },
        {
          n: "04",
          title: "İÇ KAYNAK SİNYALLERİ",
          body:
            "Süper Lig, La Liga, Serie A ve ötesinde on beş yıllık bağlantılar. Önemli bir şey olduğunda, biz kamuoyundan saatlerce önce duyuyoruz.",
        },
        {
          n: "05",
          title: "DİSİPLİNLİ TESLİMAT",
          body:
            "Gürültü yok. Süper kupon yok. Sadece staked, yapılandırılmış, yüksek değerli futbol tahminleri — kesin güven seviyesiyle birlikte gelen kutunuza teslim edilir.",
        },
      ],
    },
    plans: {
      overline: "ÜYELİK PAKETLERİ",
      title: "AVANTAJINI SEÇ.",
      subtitle:
        "Basit, dürüst fiyatlandırma. Otomatik yenilenen abonelik yok — istediğin tahmini, istediğin zaman alırsın.",
      most_popular: "EN POPÜLER",
      best_value: "EN AVANTAJLI",
      features: {
        tips: (n) => `${n} gün premium futbol tahmini`,
        analysis: "Her tahmin için tam yazılı analiz",
        odds: "Önerilen bahis şirketi & adil oran",
        stake: "Önerilen stake & güven puanı",
        support: "Öncelikli Telegram desteği",
        replacement: "Ertelenen maçlarda ücretsiz değişim",
      },
      cta: "BU PAKETİ AL",
      currency: "EUR",
      note: "Tek seferlik ödeme · Otomatik yenileme yok · Ekibimiz tarafından bizzat işlenir",
      guarantee_overline: "GARANTİMİZ",
      guarantee_before: "Her kaybeden gün",
      guarantee_highlight: "= 1 ücretsiz telafi günü",
      guarantee_after: "aboneliğiniz bittikten sonra.",
      not_available: "MEVCUT DEĞİL",
    },
    freeTip: {
      overline: "GÜNÜN ÜCRETSİZ TAHMİNİ",
      title: "GÜNÜN ÜCRETSİZ TAHMİNİ",
      free_badge: "ÜCRETSİZ",
      tip: "TAHMİN",
      odds: "ORAN",
      history: "GEÇMİŞ ÜCRETSİZ TAHMİNLER",
      match: "MAÇ",
      result: "SONUÇ",
      btn_plans: "ABONELİK PAKETİ",
      btn_archive: "ARŞİV",
      banner_disclaimer: "Web sitemizde gösterilen bannerlarla ilgili herhangi bir sorumluluk kabul etmediğimizi ve bunların yalnızca web sitemize trafik çekmek amacıyla kullanıldığını beyan ederiz.",
      note: "Ücretsiz tahmin maçları ile abonelik maçları tamamen farklıdır ve farklı tipsterlardan gelir. Temel fark, bilgi düzeyleri, bağlantıları ve adanmışlıklarıdır.",
    },
    archive: {
      overline: "GEÇMİŞ SONUÇLAR / ARŞİV",
      title: "SÖZ DEĞİL, KANIT.",
      subtitle:
        "Son premium tahminlerimizin canlı güncellenen kaydı. Kazançlar ve kayıplar — hiçbir şey saklı değil.",
      date: "TARİH",
      match: "MAÇ",
      league: "LİG",
      tip: "TAHMİN",
      odds: "ORAN",
      result: "SONUÇ",
      no_double: "ABONELİK ÇİFTİ YOK",
      win: "KAZANDI",
      loss: "KAYIP",
      draw: "BERABERE",
      full_archive: "TÜM ARŞİV İÇİN TIKLAYIN",
      view_more: "TÜM ARŞİVİ GÖR",
    },
    contact: {
      overline: "İLETİŞİME GEÇ",
      title: "MASAYLA ÇALIŞMAYA HAZIR MISIN?",
      subtitle:
        "Bize bir mesaj bırak — Hakan ya da kıdemli analistlerimizden biri 12 saat içinde bizzat yanıtlayacak.",
      name: "Adın",
      email: "E-posta adresi",
      subject: "Konu",
      message: "Mesajın",
      submit: "MESAJI GÖNDER",
      sending: "GÖNDERİLİYOR...",
      success: "Mesaj alındı. 12 saat içinde sizinle iletişime geçeceğiz.",
      error: "Bir şeyler ters gitti. Lütfen tekrar dene.",
    },
    footer: {
      tagline: "İstanbul merkezli futbol istihbaratı.",
      rights: "Tüm hakları saklıdır.",
      cols: {
        product: "ÜRÜN",
        legal: "YASAL",
        contact: "İLETİŞİM",
      },
      links: {
        home: "Anasayfa",
        plans: "Üyelik Paketleri",
        archive: "Geçmiş Sonuçlar",
        terms: "Kullanım Koşulları",
        privacy: "Gizlilik Politikası",
        disclaimer: "Sorumluluk Reddi",
        cookies: "Çerez Politikası",
        contact: "İletişim",
      },
      responsible:
        "SADECE +18. Lütfen sorumlu bir şekilde bahis yapın. Spor bahisleri risk içerir. HAKAN TIPS analitik bir hizmettir; hiçbir bahis kabul etmez, işlemez veya kolaylaştırmaz.",
    },
    testimonials: {
      overline: "ÜYE YORUMLARI",
      title: "DÜNYA ÇAPINDA GÜVENİLİYOR.",
      subtitle:
        "Doğrulanmış üyelerimizden gerçek geri bildirimler. Trustpilot'ta bağımsız değerlendirmeler.",
      trustpilot: "Trustpilot'ta Mükemmel Puan",
      score: "4.8 / 5",
      reviews: "1.247 doğrulanmış yoruma göre",
      items: [
        { name: "Marco B.", country: "İtalya 🇮🇹", stars: 5, text: "10 yıldır takip ettiğim en iyi tipster. 15 TIPS paketi bir haftasonu içinde kendini amorti etti. Her seferinde sağlam analiz." },
        { name: "Kenan Y.", country: "Türkiye 🇹🇷", stars: 5, text: "Hakan'ın Süper Lig okuması inanılmaz — 10'da 8 tutturuyor. Yazılı analizler bile fiyata değer." },
        { name: "James O.", country: "İngiltere 🇬🇧", stars: 5, text: "Sıfır boş konuşma, sahte ekran görüntüsü yok, sadece kanıt. 6 aydır üyeyim, kasa %41 arttı." },
        { name: "Andreas M.", country: "Almanya 🇩🇪", stars: 5, text: "Hızlı teslimat, net gerekçe, dürüst sonuç takibi. Profesyonel tahmincilik böyle olur." },
        { name: "Diego R.", country: "İspanya 🇪🇸", stars: 5, text: "Güven puanı sistemi oyun değiştirici. Yüksek güvenli tahminler tutarlı şekilde geliyor." },
        { name: "Ali K.", country: "BAE 🇦🇪", stars: 5, text: "Hızlı, profesyonel ve her zaman söz verdiği gibi teslim ediyor. Hizmetten ve sonuçlardan çok memnunum." },
      ],
    },
    payments: {
      overline: "GÜVENLİ ÖDEME",
      title: "BİRÇOK ÖDEME SEÇENEĞİ.",
      subtitle:
        "Geniş, güvenli ve gizli ödeme yöntemleri kabul ediyoruz. Tüm işlemler ekibimiz tarafından bizzat yürütülür — online form yok, kart verisi saklanmıyor.",
      note: "Siparişinizi tamamlamak için bize ulaşın. Talep üzerine tam talimatlar iletilir.",
      methods: [
        "Skrill",
        "Neteller",
        "PayPal",
        "Kripto (BTC / USDT / ETH)",
        "Western Union",
        "MoneyGram",
        "Ria Money Transfer",
        "Ukash",
      ],
    },
    admin: {
      login_title: "YÖNETİCİ GİRİŞİ",
      login_subtitle: "Kısıtlı alan. Yalnızca yetkili personel.",
      email: "E-posta",
      password: "Şifre",
      login: "GİRİŞ YAP",
      logout: "ÇIKIŞ",
      dashboard: "ARŞİV YÖNETİMİ",
      welcome: "Tekrar hoş geldiniz",
      add_new: "+ YENİ SONUÇ EKLE",
      edit: "DÜZENLE",
      delete: "SİL",
      save: "KAYDET",
      cancel: "İPTAL",
      confirm_delete: "Bu sonuç silinsin mi?",
      form: {
        date: "Tarih (YYYY-AA-GG)",
        league: "Lig",
        match: "Maç",
        tip: "Tahmin",
        odds: "Oran",
        result: "Sonuç",
      },
      login_error: "Geçersiz kimlik bilgileri.",
      login_success: "Giriş yapıldı.",
      saved: "Kaydedildi.",
      deleted: "Silindi.",
    },
    legal: {
      lastUpdated: "Son güncelleme: Aralık 2025",
      backHome: "← ANASAYFAYA DÖN",
      terms: {
        title: "KULLANIM KOŞULLARI",
        intro:
          "Bu Kullanım Koşulları (\"Koşullar\"), www.hakan-tips.com web sitesine (\"Site\") ve HAKAN TIPS tarafından işletilen ilgili hizmetlere (\"Hizmet\") erişiminizi ve kullanımınızı düzenler. Hizmete erişerek veya kullanarak bu Koşullara bağlı kalmayı kabul edersiniz.",
          sections: [
            { h: "1. Hizmetin Niteliği", p: "HAKAN TIPS bir bilgi ve analiz hizmetidir. Eğlence ve bilgilendirme amacıyla futbol analizleri, tahminler ve öngörüler sunarız. Bahis kabul etmez, bulundurmaz veya kolaylaştırmayız; bir bahis şirketi değiliz." },
            { h: "2. Uygunluk", p: "Hizmeti kullanmak için en az 18 yaşında (veya bulunduğunuz ülkedeki yasal reşit yaşta) olmalısınız. Tahminlerimizi kullanmanın ikamet ettiğiniz ülkede yasal olduğunu kabul edersiniz." },
            { h: "3. Garanti Yoktur", p: "Tüm tahminler istatistiksel analiz ve profesyonel yargıya dayalı görüşlerdir. Geçmiş performans, gelecekteki sonuçların göstergesi değildir. Kâr garantisi vermeyiz ve içeriklerimiz kullanılarak yapılan mali kayıplardan sorumlu tutulamayız." },
            { h: "4. Satın Alma & İade", p: "Üyelik tahminleri tek seferlik olarak satılır. İçeriğin dijital ve zamana duyarlı doğası nedeniyle, tahminler teslim edildikten sonra tüm satışlar kesindir ve iade edilemez." },
            { h: "5. Fikri Mülkiyet", p: "Sitedeki tüm içerik, analiz, marka ve kod HAKAN TIPS'e aittir. Yazılı iznimiz olmadan tahminlerimizi yeniden satamaz, dağıtamaz veya yayınlayamazsınız." },
            { h: "6. Hesap Davranışı", p: "Hizmeti kötüye kullanmamayı, ücretli içeriği paylaşmamayı ve yasa dışı hiçbir amaçla kullanmamayı kabul edersiniz. Bu Koşulların ihlali durumunda erişimi iade yapmaksızın askıya alabiliriz." },
            { h: "7. Sorumluluğun Sınırlandırılması", p: "Yasaların izin verdiği azami ölçüde, HAKAN TIPS, Hizmetin kullanımından kaynaklanan dolaylı, arızi veya sonuç niteliğindeki zararlardan sorumlu değildir." },
            { h: "8. Uygulanacak Hukuk", p: "Bu Koşullar Türkiye Cumhuriyeti yasalarına tabidir. Her türlü uyuşmazlıkta İstanbul mahkemeleri yetkilidir." },
            { h: "9. Değişiklikler", p: "Bu Koşulları istediğimiz zaman güncelleyebiliriz. Değişikliklerin ardından Sitenin kullanılmaya devam edilmesi güncel Koşulların kabulü anlamına gelir." },
          ],
      },
      privacy: {
        title: "GİZLİLİK POLİTİKASI",
        intro:
          "Bu Gizlilik Politikası, www.hakan-tips.com kullanıldığında HAKAN TIPS'in kişisel bilgilerinizi nasıl topladığını, kullandığını ve koruduğunu açıklar.",
          sections: [
            { h: "1. Topladığımız Bilgiler", p: "İletişim formumuz aracılığıyla doğrudan sağladığınız bilgileri (ad, e-posta, mesaj içeriği) ve standart analiz araçlarıyla temel teknik verileri (IP adresi, tarayıcı türü, görüntülenen sayfalar) toplarız." },
            { h: "2. Verilerinizi Nasıl Kullanırız", p: "Verileriniz yalnızca taleplerinize yanıt vermek, satın alınan tahminleri teslim etmek, Siteyi geliştirmek ve yasal yükümlülükleri karşılamak için kullanılır. Verilerinizi satmayız." },
            { h: "3. Yasal Dayanak", p: "Kişisel verileri GDPR ve Türk KVKK ile uyumlu olarak rıza, sözleşmenin ifası ve meşru menfaat yasal dayanakları çerçevesinde işleriz." },
            { h: "4. Veri Paylaşımı", p: "Verileri yalnızca sıkı veri işleme sözleşmeleri kapsamında güvenilir işleyicilerle (barındırma, e-posta iletimi, analiz) paylaşırız. Verilerinizi asla bahis operatörleriyle paylaşmayız." },
            { h: "5. Veri Saklama", p: "İletişim mesajları en fazla 24 ay saklanır. Silme talebinizi istediğiniz zaman privacy@hakan-tips.com adresinden iletebilirsiniz." },
            { h: "6. Haklarınız", p: "Kişisel verilerinize erişme, düzeltme, silme, kısıtlama ve taşıma ile onayı istediğiniz zaman geri alma hakkına sahipsiniz." },
            { h: "7. Güvenlik", p: "Sektör standardı şifreleme (TLS) ve erişim kontrolleri kullanırız. Ancak internet üzerinden iletim yönteminin hiçbiri %100 güvenli değildir." },
            { h: "8. İletişim", p: "Her türlü gizlilik sorusu için privacy@hakan-tips.com ile iletişime geçin." },
          ],
      },
      disclaimer: {
        title: "SORUMLULUK REDDİ",
        intro:
          "www.hakan-tips.com üzerinde HAKAN TIPS tarafından sağlanan bilgiler yalnızca genel bilgilendirme ve eğlence amaçlıdır.",
          sections: [
            { h: "1. Finansal Tavsiye Değildir", p: "Bu Sitedeki hiçbir şey finansal, yatırım veya profesyonel tavsiye teşkil etmez. Bahis oynama kararı tamamen sizin takdirinize ve riskinize bağlıdır." },
            { h: "2. Bahis Riski", p: "Spor bahisleri önemli mali risk içerir. Yatırdığınız tüm parayı kaybedebilirsiniz. Yalnızca rahatlıkla kaybedebileceğiniz miktarları oynayın." },
            { h: "3. Sorumlu Bahis", p: "Siz veya tanıdığınız biri kumar bağımlılığı yaşıyorsa lütfen BeGambleAware, GamCare veya Türkiye Yeşilay Cemiyeti gibi bir yardım hattıyla iletişime geçin." },
            { h: "4. Harici Bağlantılar", p: "Site üçüncü taraf web sitelerine bağlantılar içerebilir. Bu sitelerin içeriğinden, doğruluğundan veya uygulamalarından sorumlu değiliz." },
            { h: "5. Garanti Yoktur", p: "Tüm içerik açık veya zımni herhangi bir garanti olmaksızın \"olduğu gibi\" sağlanır." },
          ],
      },
      cookies: {
        title: "ÇEREZ POLİTİKASI",
        intro:
          "Bu Çerez Politikası, HAKAN TIPS'in www.hakan-tips.com üzerinde çerezleri ve benzer teknolojileri nasıl kullandığını açıklar.",
          sections: [
            { h: "1. Çerez Nedir?", p: "Çerezler, sitelerin çalışmasına, tercihleri hatırlamasına ve trafiği analiz etmesine yardımcı olan, cihazınızda saklanan küçük metin dosyalarıdır." },
            { h: "2. Kullandığımız Çerez Türleri", p: "Kesinlikle gerekli çerezler (site işlevselliği), tercih çerezleri (dil seçimi) ve ziyaretçilerin Siteyi nasıl kullandığını anlamak için anonim analiz çerezleri kullanırız." },
            { h: "3. Üçüncü Taraf Çerezleri", p: "Bazı çerezler Google Analytics gibi üçüncü taraf hizmetler tarafından yerleştirilebilir. Bu sağlayıcıların kendi gizlilik politikaları vardır ve incelemenizi öneririz." },
            { h: "4. Çerezleri Yönetme", p: "Tarayıcı ayarlarınızdan istediğiniz zaman çerezleri kontrol edebilir veya silebilirsiniz. Bazı çerezleri engellemek Sitenin işlevselliğini etkileyebilir." },
            { h: "5. Güncellemeler", p: "Bu Çerez Politikasını periyodik olarak güncelleyebiliriz. Üstteki tarih en son revizyonu yansıtır." },
          ],
      },
    },
  },
};
